// @ts-ignore
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireQuestionPriceFragmentDoc = gql`
    fragment questionnaireQuestionPrice on QuestionnaireQuestionPrice {
  id
  title
  required
  tooltip
  min
  max
}
    `;